import React from 'react'

const Footer = () => {
  return (
    <div>
        <div class="footer-basic ">
    <footer style={{bottom: 0,width:"100%;"}}>
        <div class="social">
        <a ><i class="fab fa-linkedin-in"></i></a>
        <a ><i class="fab fa-instagram"></i></a>
        <a ><i class="fab fa-facebook-f"></i></a>
      </div>
        <p class="copyright">Copyright© 2022Webinar</p>
    </footer>
  </div>
    </div>
  )
}

export default Footer
